import React from 'react'
import { Flex, Text } from '../../../core-components'

interface Props {
  children: React.ReactNode
}

export const OverflowPill = ({ children }: Props) => {
  return (
    <Flex
      px={2}
      h='28px'
      alignItems='center'
      borderRadius={8}
      flexShrink={0}
      bg='bg/button-moderate'
    >
      <Text textStyle='form-value' color='text/form-value'>
        {children}
      </Text>
    </Flex>
  )
}
